import { render, staticRenderFns } from "./LoadsBySpeciesTotal.vue?vue&type=template&id=d04b5f8c&"
import script from "./LoadsBySpeciesTotal.vue?vue&type=script&lang=js&"
export * from "./LoadsBySpeciesTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports